module.exports = __webpack_public_path__ + "img/84.f79c7b7e.jpg";